import { render, staticRenderFns } from "./VynosND.vue?vue&type=template&id=2bc3bb29&"
import script from "./VynosND.vue?vue&type=script&lang=ts&"
export * from "./VynosND.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports